// extracted by mini-css-extract-plugin
export default {"backToTop":"Footer_backToTop__euLRH","show":"Footer_show__2aMc6","footerNav":"Footer_footerNav__qbWS6"};